import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon } from 'modules/common/components';
import { SortableWrapper, SortItem, DragHandler } from '../styles/sort';
import { reorder } from '../utils';
import EmptyState from './EmptyState';

const propTypes = {
  fields: PropTypes.array,
  child: PropTypes.func,
  onChangeFields: PropTypes.func,
  isModal: PropTypes.bool,
  zIndex: PropTypes.string,
  showDragHandler: PropTypes.bool
};

const defaultProps = {
  showDragHandler: true
};

class SortableList extends Component {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    const { destination, source } = result;

    // dropped outside the list
    if (!destination) return;

    if (destination.index === source.index) {
      return;
    }

    const { fields, onChangeFields } = this.props;

    const reorderedFields = reorder(fields, source.index, destination.index);

    onChangeFields(reorderedFields);
  }

  renderDragHandler() {
    if (!this.props.showDragHandler) return;

    return (
      <DragHandler>
        <Icon icon="move" />
      </DragHandler>
    );
  }

  renderField(field, index) {
    const { child, isModal } = this.props;

    return (
      <Draggable draggableId={field._id} index={index} key={index}>
        {(provided, snapshot) => (
          <Fragment>
            <SortItem
              innerRef={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              isDragging={snapshot.isDragging}
              isModal={isModal}
              zIndex={this.props.zIndex}
            >
              {this.renderDragHandler()}

              {child(field)}
            </SortItem>
            {provided.placeholder}
          </Fragment>
        )}
      </Draggable>
    );
  }

  renderFields(provided) {
    const { fields } = this.props;

    if(fields && typeof fields === "object" && fields.length > 0)
    {
      return (
        <SortableWrapper innerRef={provided.innerRef}>
          {fields.map((field, index) => this.renderField(field, index))}
        </SortableWrapper>
      );
    }
    else
    {
      return (
        <SortableWrapper innerRef={provided.innerRef}>
        
        </SortableWrapper>
      );
    }
  }

  render() {
    if (this.props.fields.length === 0) {
      return <EmptyState text="There is no data" icon="ban" />;
    }
    else {
      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppableId" type="ITEMS">
            {provided => this.renderFields(provided)}
          </Droppable>
        </DragDropContext>
      );
    }
  }
}

SortableList.propTypes = propTypes;
SortableList.defaultProps = defaultProps;

export default SortableList;



// WEBPACK FOOTER //
// src/modules/common/components/SortableList.js